import { render, staticRenderFns } from "./CaseProgress.vue?vue&type=template&id=704ee57d"
import script from "./CaseProgress.vue?vue&type=script&lang=js"
export * from "./CaseProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports